// WebSocketContext.js
import React, { createContext, useContext, useEffect, useRef, useState } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";

const WebSocketContext = createContext();

export const WebSocketProvider = ({ children }) => {
  const [userId, setUserId] = useState(localStorage.getItem("userId"));
  const [isConnected, setIsConnected] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);
  const [chatSummaries, setChatSummaries] = useState([]);
  const stompClientRef = useRef(null);

  useEffect(() => {
    if (!userId) return;
    

    const socket = new SockJS(`${window.REACT_APP_FILEDOWNLOAD_URL}:8444/Openrecruiter/ws`);

    const client = new Client({
      webSocketFactory: () => socket,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 5000,
      reconnectDelay: 5000,

      onConnect: () => {
        console.log("✅ Connected to WebSocket for user:", userId);
        setIsConnected(true);
        client.subscribe(`/topic/chat-recent-list/${userId}`, (message) => {
          const summaries = JSON.parse(message.body);
          setChatSummaries(summaries);

          const totalUnread = summaries.reduce(
            (sum, chat) => sum + (chat.unreadMessagesCount || 0),
            0
          );
          setUnreadCount(totalUnread);
        });

        client.subscribe(`/topic/chat-recent/${userId}`, (message) => {
          const chatSummary = JSON.parse(message.body);
          console.log("🔔 Chat recent update:", chatSummary);

          setChatSummaries((prev) => {
            const updated = [...prev];
            const idx = updated.findIndex((u) => u.userId === chatSummary.userId);
            if (idx > -1) {
              updated[idx] = chatSummary;
            } else {
              updated.unshift(chatSummary);
            }

            const totalUnread = updated.reduce(
              (sum, chat) => sum + (chat.unreadMessagesCount || 0),
              0
            );
            setUnreadCount(totalUnread);

            return updated;
          });
        });

        client.publish({
          destination: "/app/chat-recent-list",
          body: JSON.stringify({ userId }),
        });
      },

      onDisconnect: () => {
        console.log("⚠️ Disconnected from WebSocket");
        setIsConnected(false);
      },

      onStompError: (frame) => {
        console.error("❌ Broker error:", frame.headers["message"]);
      },
    });

    stompClientRef.current = client;
    client.activate();

    return () => {
      client.deactivate();
    };
  }, [userId]);  

  return (
    <WebSocketContext.Provider
      value={{ isConnected, unreadCount, chatSummaries, setUserId }}
    >
      {children}
    </WebSocketContext.Provider>
  );
};

export const useWebSocket = () => useContext(WebSocketContext);
